import { CustomAction } from "..";
import { PrivacyGeoIPOverride, PrivacyPolicyLang } from "../../types/privacy";
import { PRIVACY_POLICY_TYPES } from "../actions-types";

export const actionSetPrivacyLanguageRegion = (
  data: PrivacyPolicyLang
): CustomAction => {
  return {
    type: PRIVACY_POLICY_TYPES.SET_LANGUAGE_REGION,
    data,
  };
};

export const actionSetGeoIPOverride = (
  data: PrivacyGeoIPOverride
): CustomAction => {
  return {
    type: PRIVACY_POLICY_TYPES.SET_GEOIP_OVERRIDE,
    data,
  };
};
